import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// 🔥 URL RENDER CORRIGÉE + ROUTE CORRIGÉE
const API_BASE_URL = 
  window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://veryfit.onrender.com";

const DeclarationCEPreview = () => {
  const { orderId } = useParams();
  const [pdfUrl, setPdfUrl] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPDF = async () => {
      try {
        console.log("🔍 Génération PDF CE pour dossier:", orderId);
        console.log("🌐 API URL utilisée:", API_BASE_URL);
        
        // 🔥 ROUTE CORRIGÉE: /api/generate/ au lieu de /api/dossiers/generate/
        const url = `${API_BASE_URL}/api/generate/declaration-ce/${orderId}`;
        console.log("📄 URL complète:", url);
        
        const res = await fetch(url);
        
        if (!res.ok) {
          throw new Error(`Erreur lors de la génération du PDF CE (${res.status}): ${res.statusText}`);
        }

        const blob = await res.blob();
        const pdfObjectUrl = window.URL.createObjectURL(blob);
        setPdfUrl(pdfObjectUrl);
        console.log("✅ PDF CE généré avec succès");
        
      } catch (err) {
        console.error("❌ Erreur génération PDF CE:", err);
        setError(`Impossible de générer le PDF CE: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    if (orderId) {
      fetchPDF();
    }
  }, [orderId]);

  // Nettoyer l'URL de l'objet quand le composant se démonte
  useEffect(() => {
    return () => {
      if (pdfUrl) {
        window.URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [pdfUrl]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-slate-100 flex items-center justify-center">
        <div className="text-center space-y-4">
          <div className="relative">
            <div className="w-16 h-16 border-4 border-blue-200 rounded-full animate-spin"></div>
            <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin absolute top-0 left-0"></div>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Génération en cours</h3>
            <p className="text-gray-600">Création de la déclaration CE...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-slate-100 flex items-center justify-center">
        <div className="bg-white rounded-2xl shadow-sm border border-red-200 p-8 max-w-md mx-auto">
          <div className="text-center">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Erreur de génération</h3>
            <p className="text-red-600 text-center mb-4">{error}</p>
            <button
              onClick={() => window.location.reload()}
              className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
            >
              Réessayer
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-slate-100">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <button 
                onClick={() => window.history.back()}
                className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors p-2 hover:bg-gray-100 rounded-lg"
              >
                <span className="text-lg">←</span>
                <span className="font-medium">Retour</span>
              </button>
              <div className="h-6 w-px bg-gray-300"></div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl flex items-center justify-center shadow-lg">
                  <span className="text-white font-bold text-xl">📋</span>
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-900">Déclaration de Conformité CE</h1>
                  <p className="text-sm text-gray-600">
                    Dossier: {orderId}
                  </p>
                </div>
              </div>
            </div>
            
            {/* Actions */}
            <div className="flex items-center gap-3">
              <a
                href={pdfUrl}
                download={`Declaration-CE-${orderId}.pdf`}
                className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors text-sm font-medium shadow-sm"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Télécharger
              </a>
              
              <a
                href={pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg transition-colors text-sm font-medium shadow-sm"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
                Ouvrir dans un nouvel onglet
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Contenu PDF */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
          {pdfUrl ? (
            <iframe
              src={`${pdfUrl}#view=FitH&navpanes=0&toolbar=1`}
              title="Déclaration CE"
              className="w-full h-[80vh] border-0"
            />
          ) : (
            <div className="flex items-center justify-center h-[80vh]">
              <div className="text-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <p className="text-gray-500">Chargement du PDF...</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeclarationCEPreview;